import { useMemo } from "react";
import { useMarketplaceLabel, useMarketplaceOptions } from "../../../utils/marketplaceConstants";
import { NavDropdown } from "react-bootstrap";
import Flags from "country-flag-icons/react/3x2";

const MarketplaceStatsFilter = ({ selectedMarketplace, setSelectedMarketplace, allowedMarketplaces }) => {
  const marketplaceOptions = useMarketplaceOptions();
  const getMarketplaceLabel = useMarketplaceLabel();
  const options = useMemo(() => {
    if (!allowedMarketplaces) return marketplaceOptions;
    return marketplaceOptions.filter((opt) => allowedMarketplaces.includes(opt.value));
  }, [allowedMarketplaces, marketplaceOptions]);

  let flagNationCode = selectedMarketplace;

  if (flagNationCode === "USA") {
    flagNationCode = "US";
  }

  if (flagNationCode === "UK") {
    flagNationCode = "GB";
  }
  const Flag = Flags[flagNationCode];

  return (
    <NavDropdown
      id="DateBreadcrumbComparison"
      title={
        <>
          {" "}
          <Flag style={{ width: "18px", marginRight: "8px" }} />
          {getMarketplaceLabel(selectedMarketplace)}
        </>
      }
      className={"fs-standard d-flex justify-content-center"}
      style={{ minWidth: "180px" }}
    >
      {options.map((option) => (
        <NavDropdown.Item key={option.value} title={option.label} onClick={() => setSelectedMarketplace(option.value)}>
          {option.label}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );
};

export default MarketplaceStatsFilter;
